<div class="f-size-sm hotel-star" *ngIf="starsCount > 0">
  <i class="rx-star pr-1" *ngFor="let star of stars"></i>
</div>
